/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreatePriceTierDto } from '../models/work-create-price-tier-dto';
import { WorkPriceTier } from '../models/work-price-tier';
import { WorkUpdatePriceTierDto } from '../models/work-update-price-tier-dto';

@Injectable({ providedIn: 'root' })
export class WorkPriceTiersV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `priceTiersV2ControllerCreate()` */
  static readonly PriceTiersV2ControllerCreatePath = '/v2/price-tiers';

  /**
   * Required permissions: prices:create
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceTiersV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  priceTiersV2ControllerCreate$Response(
    params: {
      body: WorkCreatePriceTierDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPriceTier>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPriceTiersV2Service.PriceTiersV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPriceTier>;
      })
    );
  }

  /**
   * Required permissions: prices:create
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceTiersV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  priceTiersV2ControllerCreate(
    params: {
      body: WorkCreatePriceTierDto
    },
    context?: HttpContext
  ): Observable<WorkPriceTier> {
    return this.priceTiersV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPriceTier>): WorkPriceTier => r.body)
    );
  }

  /** Path part for operation `priceTiersV2ControllerFindByItemId()` */
  static readonly PriceTiersV2ControllerFindByItemIdPath = '/v2/price-tiers/item/{itemId}';

  /**
   * Required permissions: prices:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceTiersV2ControllerFindByItemId()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceTiersV2ControllerFindByItemId$Response(
    params: {
      itemId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkPriceTier>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPriceTiersV2Service.PriceTiersV2ControllerFindByItemIdPath, 'get');
    if (params) {
      rb.path('itemId', params.itemId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkPriceTier>>;
      })
    );
  }

  /**
   * Required permissions: prices:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceTiersV2ControllerFindByItemId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceTiersV2ControllerFindByItemId(
    params: {
      itemId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkPriceTier>> {
    return this.priceTiersV2ControllerFindByItemId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkPriceTier>>): Array<WorkPriceTier> => r.body)
    );
  }

  /** Path part for operation `priceTiersV2ControllerFindApplicable()` */
  static readonly PriceTiersV2ControllerFindApplicablePath = '/v2/price-tiers/applicable';

  /**
   * Required permissions: prices:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceTiersV2ControllerFindApplicable()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceTiersV2ControllerFindApplicable$Response(
    params: {
      itemId: number;
      quantity: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPriceTier>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPriceTiersV2Service.PriceTiersV2ControllerFindApplicablePath, 'get');
    if (params) {
      rb.query('itemId', params.itemId, {});
      rb.query('quantity', params.quantity, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPriceTier>;
      })
    );
  }

  /**
   * Required permissions: prices:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceTiersV2ControllerFindApplicable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceTiersV2ControllerFindApplicable(
    params: {
      itemId: number;
      quantity: number;
    },
    context?: HttpContext
  ): Observable<WorkPriceTier> {
    return this.priceTiersV2ControllerFindApplicable$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPriceTier>): WorkPriceTier => r.body)
    );
  }

  /** Path part for operation `priceTiersV2ControllerGetApplicableDiscount()` */
  static readonly PriceTiersV2ControllerGetApplicableDiscountPath = '/v2/price-tiers/applicable-discount';

  /**
   * Required permissions: prices:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceTiersV2ControllerGetApplicableDiscount()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceTiersV2ControllerGetApplicableDiscount$Response(
    params: {
      itemId: number;
      quantity: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPriceTiersV2Service.PriceTiersV2ControllerGetApplicableDiscountPath, 'get');
    if (params) {
      rb.query('itemId', params.itemId, {});
      rb.query('quantity', params.quantity, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: prices:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceTiersV2ControllerGetApplicableDiscount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceTiersV2ControllerGetApplicableDiscount(
    params: {
      itemId: number;
      quantity: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.priceTiersV2ControllerGetApplicableDiscount$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `priceTiersV2ControllerFindOne()` */
  static readonly PriceTiersV2ControllerFindOnePath = '/v2/price-tiers/{id}';

  /**
   * Required permissions: prices:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceTiersV2ControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceTiersV2ControllerFindOne$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPriceTier>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPriceTiersV2Service.PriceTiersV2ControllerFindOnePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPriceTier>;
      })
    );
  }

  /**
   * Required permissions: prices:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceTiersV2ControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceTiersV2ControllerFindOne(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkPriceTier> {
    return this.priceTiersV2ControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPriceTier>): WorkPriceTier => r.body)
    );
  }

  /** Path part for operation `priceTiersV2ControllerRemove()` */
  static readonly PriceTiersV2ControllerRemovePath = '/v2/price-tiers/{id}';

  /**
   * Required permissions: prices:delete
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceTiersV2ControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceTiersV2ControllerRemove$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPriceTiersV2Service.PriceTiersV2ControllerRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: prices:delete
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceTiersV2ControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceTiersV2ControllerRemove(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.priceTiersV2ControllerRemove$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `priceTiersV2ControllerUpdate()` */
  static readonly PriceTiersV2ControllerUpdatePath = '/v2/price-tiers/{id}';

  /**
   * Required permissions: prices:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceTiersV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  priceTiersV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdatePriceTierDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPriceTier>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPriceTiersV2Service.PriceTiersV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPriceTier>;
      })
    );
  }

  /**
   * Required permissions: prices:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceTiersV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  priceTiersV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdatePriceTierDto
    },
    context?: HttpContext
  ): Observable<WorkPriceTier> {
    return this.priceTiersV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPriceTier>): WorkPriceTier => r.body)
    );
  }

}
